<template>
    <v-app>
        <h4 class="display-2 text-xs-center">Remarks</h4>
        <v-container fluid class="justify-center">
            Muscle Imbalance: 
            <v-layout row wrap>
            <v-flex xs6>
                <v-checkbox v-model="upperCheck" label="Upper"></v-checkbox>
            </v-flex>
            <v-flex xs6>
                <v-radio-group v-model="imbalance.upper" :disabled="!upperCheck" row>
                    <v-radio label="Left" value="left"></v-radio>
                    <v-radio label="Right" value="right"></v-radio>
                </v-radio-group> 
            </v-flex>
            <v-flex xs6>
                <v-checkbox v-model="middleCheck" label="Middle"></v-checkbox>
            </v-flex>
            <v-flex xs6>
                <v-radio-group v-model="imbalance.middle" :disabled="!middleCheck" row>
                    <v-radio label="Left" value="left"></v-radio>
                    <v-radio label="Right" value="right"></v-radio>
                </v-radio-group> 
            </v-flex>
            <v-flex xs6>
                <v-checkbox v-model="lowerCheck" label="Lower"></v-checkbox>
            </v-flex>
            <v-flex xs6>
                <v-radio-group v-model="imbalance.lower" :disabled="!lowerCheck" row>
                    <v-radio label="Left" value="left"></v-radio>
                    <v-radio label="Right" value="right"></v-radio>
                </v-radio-group> 
            </v-flex>
            </v-layout>
            Scoliosis: 
            <v-layout row wrap>
            <v-flex xs6>
                <v-checkbox v-model="lumbarCheck" label="Lumbar"></v-checkbox>
            </v-flex>
            <v-flex xs6>
                <v-radio-group v-model="scoliosis.lumbar" :disabled="!lumbarCheck" row>
                    <v-radio label="Left" value="left"></v-radio>
                    <v-radio label="Right" value="right"></v-radio>
                </v-radio-group> 
            </v-flex>
            <v-flex xs6>
                <v-checkbox v-model="throacicCheck" label="Thoracic"></v-checkbox>
            </v-flex>
            <v-flex xs6>
                <v-radio-group v-model="scoliosis.thoracic" :disabled="!throacicCheck" row>
                    <v-radio label="Left" value="left"></v-radio>
                    <v-radio label="Right" value="right"></v-radio>
                </v-radio-group> 
            </v-flex>
            </v-layout>
            Multifidus Over Activity: {{ multifidus ? 'Yes' : 'No' }}
            <v-switch v-model="multifidus"></v-switch>
            <v-textarea label="Remark" v-model="remark"></v-textarea>
        </v-container>
    </v-app>
</template>
<script>
import db from '@/components/firebase.init'
export default {
    data(){
        return{
            remark: '',
            scoliosis: {
                lumbar: '',
                thoracic: '',
            },
            imbalance:{
                upper: '',
                middle: '',
                lower: '',
            },
            lumbarCheck: false,
            throacicCheck: false,
            upperCheck: false,
            middleCheck: false,
            lowerCheck: false,
            scoliosis: false,
            multifidus: false,
        }
    },
    methods:{
        submit(id){
            db.collection('forms').doc(id).update(
                {
                    imbalance: this.imbalance,
                    scoliosis: this.scoliosis,
                    multifidus: this.multifidus,
                    remark: this.remark
                }
            )
        }
    }
}
</script>
<style scoped>
.section{
    border-bottom: 1px solid rgb(233, 233, 233);
}
</style>


